import React from 'react';

import Link from 'buyside/components/presentation/Link/link';

import styles from './eventRegistrationButtonSubtitleStyles.scss';

const EventRegistrationButtonSubtitle = (): React.ReactElement => {
  return (
    <div className={styles.registrationButtonSubtitle}>
      <div>
        <div>Wednesday, May 28th, 2025 | 12:00pm to 6:00pm EST</div>
        <div>Open Jar Studios | 1601 Broadway - 11th floor, New York, NY 10019</div>
      </div>
      <p>
        Questions? Contact <Link to="mailto:support@sumzero.com">support@sumzero.com</Link>
      </p>
    </div>
  );
};

export default EventRegistrationButtonSubtitle;
